export const beforeItems: string[] = [
  'Passer des heures à préparer chaque séance depuis zéro',
  "Improviser la progression d'un cours à l'autre, sans structure réelle",
  'Ne pas savoir comment adapter une séance pour une élève enceinte, en rééducation ou senior',
  "Craindre d'oublier un point de sécurité important sur le Reformer",
  'Recommencer les mêmes exercices de base par manque de nouveauté organisée',
]

export const afterItems: string[] = [
  'Ouvrez le niveau du jour et suivez une séance déjà structurée',
  'Une progression claire sur 6 niveaux, testée bloc par bloc',
  'Un guide dédié pour grossesse, rééducation et troisième âge, inclus',
  "Une checklist de sécurité et d'entretien du Reformer toujours à portée de main",
  '144 exercices classés par difficulté, jamais à court de contenu',
]

export const transformationStats: [string, string][] = [
  ['360', "PAGES PRÊTES À L'EMPLOI"],
  ['6 NIVEAUX', 'DE PROGRESSION CONTINUE'],
  ['144', 'EXERCICES CLASSÉS PAR NIVEAU'],
]
